import React from 'react';
import cn from 'classnames';
import style from './divider.mod.scss';
import { motion } from 'framer-motion';

const Divider = ({ disablePadding = false }) => {
  const classes = cn(style.divider, {
    [style[`divider--padding-none`]]: disablePadding,
  });

  const contentVariants = {
    offscreen: {
      opacity: 0,
    },
    onscreen: {
      opacity: 1,
      transition: {
        duration: 0.3,
        delay: 0.1,
      },
    },
  };

  return (
    <motion.div
      variants={contentVariants}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, amount: 0.1 }}
    >
      <div className={classes}></div>
    </motion.div>
  );
};

export default Divider;
